import { ICommonOrder, IPurchaseDomainType } from '@cuspar/ywt.ch.model';

export function getUnpaidRenewalOrders(orders: ICommonOrder[]): ICommonOrder[] {
  return orders.filter((order) => {
    const status = order.stripeInvoice?.status;
    return !order.supersededByOrderId && (status === 'open' || status === 'draft') && order.domains.some((domain) => domain.type === IPurchaseDomainType.Renewal);
  });
}

export function getOrderAmountDue(order: ICommonOrder): number {
  return order.stripeInvoice?.amount_remaining ?? order.stripeInvoice?.total ?? 0;
}

export function getRenewalOrdersAmountDue(orders: ICommonOrder[]): number {
  return orders.reduce((sum, order) => sum + getOrderAmountDue(order), 0);
}
